import React from 'react';


interface IFooterBarProps {
  logoutUser: any;
}
export default class FooterBar extends React.Component<IFooterBarProps> {
  static defaultProps: IFooterBarProps = {
    logoutUser: undefined,
  };

  handleLogout = (e): void => {
    e.preventDefault();
    this.props.logoutUser();
  };

  render(): React.ReactNode {
    return (
      <div className="footer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col">
              <div className="row justify-content-center footer-links">
                <a
                  href="https://www.teammo.com.au/policies/terms-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-grey"
                >
                  Terms of Use
                </a>
                <a
                  href="http://help.teammo.com.au"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-grey"
                >
                  Support
                </a>
                <a className="text-grey" onClick={this.handleLogout}>
                  Sign Out
                </a>
              </div>
              <div className="row justify-content-center">
                <span className="text-grey footer-version">
                  Teammo | version 3
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
